import { useEffect, useState } from "react";
import ToolBar from "../../../components/ToolBar";
import CreateButton from "../../../components/ToolBar/Buttons/CreateButton";
import RecordPerPage from "../../../components/ToolBar/Dropdown/RecordPerPage";
import ContentBox from "../../../components/ContentBox/ContentBox";
import Listing from "./components/Listing/Listing";
import { setPerPage, setDetails, fetchList, details } from "./utils/slice";
import DeleteModal from "../../../components/Modals/DeleteModal";
// import AddComponent from "./components/Form/AddComponent";
// import EditComponent from "./components/Form/EditComponent";
import { ActivityLogBreadcrumb } from "../../../config/BreadcrumbConfig";
import { toUpperCaseWithUnderscore, validateFields } from "../../../utils/commonFunctions";
import { useAppDispatch, useAppSelector } from "../../../utils/hooks/hooks";
// import ImportComponent from "./components/Form/ImportComponent";
import React from "react";
import ViewDrawer from "./components/ViewDrawer";
import { CONSTANT } from "../../../config/Constant";
import { setViewLoading } from "../../../store/CommonSlice";
import { Card, Col, Form, message, Row, Space } from "antd";
import CancelButton from "../../../components/Buttons/CancelButton";
import SaveButton from "../../../components/Buttons/SaveButton";
import { FormBox, InputBox } from "../../../components/AntdAddons";
import { dateFormats } from "./utils/constats";
import dayjs from "dayjs";

const moduleInfo = {
  title: "Activity Log",
  permissionKeyPrefix: toUpperCaseWithUnderscore("Activity Log"),
};

/**
 * Renders the Activity Log Management component.
 *
 * @return {ReactElement} The rendered ActivityLogManagement component.
 */
const ActivityLogManagement: React.FC<any> = () => {
  const dispatch = useAppDispatch();
  const { perPage } = useAppSelector((state) => state.experience);
  const [viewDrawer, setViewDrawer] = useState(false);

  useEffect(() => {
    onReset();
    // dispatch(fetchList()).catch((error: any) => error);
  }, []);


  const getDetails = (data: any, type: string) => {
    dispatch(setViewLoading([true, data.id]));
    dispatch(details(data.id))
      .then(() => {
        if (type === CONSTANT.DRAWER_TYPE.VIEW) {
          setViewDrawer(true);
          dispatch(setViewLoading([false, data.id]));
        }

      })
      .catch((error: any) => error);
  };


  const [form] = Form.useForm();
  const [disabled, setDisabled] = useState<boolean>(true);
  const [saving, setSaving] = useState<boolean>(false);
  const [startDate, setStartDate] = useState<any>(null);
  const [endDate, setEndDate] = useState<any>(null);
  const [showMoreFiltes, setShowMoreFiltes] = useState<any>(false);


  const onValuesChange = () => {

    console.log(form);
    validateFields(form, setDisabled);
  };

  const minDate = dayjs();

  const disableDate = (current: any, type = "start", date: any = null) => {
    if (current > dayjs()) return true;
    if (date == null) {
      return false;
    }
    return current && (type == "start" ? current > dayjs(date) : current < dayjs(date));
  };



  const onFinish = (data: any) => {
    console.log('data', data);
    let error = 0;
    if (!data.start_date && data.end_date) {
      message.error('Please select start date');
      error++;
    }
    if (!data.end_date && data.start_date) {
      message.error('Please select end date');
      error++;
    }
    if (!data.ageMin && data.ageMax) {
      message.error('Please select min age');
      error++;
    }
    if (!data.ageMax && data.ageMin) {
      message.error('Please select max age');
      error++;
    }
    if (error > 0) {
      return 0;
    }

    var requestData: any = {
      start_date: '',
      end_date: '',
      // career_category: data?.career_category || [],
      // skill_category: data?.skill_category || [],
    }
    if (data.start_date && data.end_date) {
      requestData.start_date = dayjs(data.start_date).format('YYYY-MM-DD');
      requestData.end_date = dayjs(data.end_date).format('YYYY-MM-DD');
    }


    dispatch(fetchList(requestData)).then((response: any) => {
      console.log('response', response)
      // setDetailsObj(response.data)
      // setIsLoading(false)
    }).catch((error: any) => error);

  }




  const onReset = () => {
    form.resetFields();
    form.setFieldValue('start_date', minDate);
    form.setFieldValue('end_date', minDate);
    setStartDate(null);
    setEndDate(null);
    setDisabled(true);
    // setIsLoading(true)
    const requestData = {
      start_date: '',
      end_date: '',
    }
    requestData.start_date = dayjs(minDate).format('YYYY-MM-DD');
    requestData.end_date = dayjs(minDate).format('YYYY-MM-DD');
    dispatch(fetchList(requestData)).then((response: any) => {
      console.log('response', response)
      // setDetailsObj(response.data)
      // setIsLoading(false)
    }).catch((error: any) => error);
  };



  const FilterForm: any = <FormBox
    form={form}
    id={'filterForm'}
    onFinish={onFinish}
    onValuesChange={onValuesChange}
  >

    <Row gutter={[0, 0]}>
      <Col xs={{ span: 24 }} md={{ span: 24 }} xxl={{ span: 20 }}>
        <Row gutter={[15, 15]}>

          <Col xs={{ span: 24 }} md={{ span: 24 }} xl={{ span: 12 }} xxl={{ span: 6 }}>
            <InputBox.DatePicker
              style={{ marginBottom: 0 }}
              placeholder="Select Start Date"
              name="start_date"
              format={dateFormats.dateFormat}
              onChange={(date) => setStartDate(date)}
              disabledDate={(date) => disableDate(date, 'start', endDate)}
              defaultPickerValue={minDate}
              allowClear={false}
              inputReadOnly
            // defaultValue={minDate}


            />
          </Col>
          <Col xs={{ span: 24 }} md={{ span: 24 }} xl={{ span: 12 }} xxl={{ span: 6 }} >
            <InputBox.DatePicker
              style={{ marginBottom: 0 }}
              placeholder="Select End Date"
              name="end_date"
              format={dateFormats.dateFormat}
              onChange={(date) => setEndDate(date)}
              disabledDate={(date) => disableDate(date, 'end', startDate)}
              defaultPickerValue={minDate}
              allowClear={false}
              inputReadOnly
            // defaultValue={minDate}
            />
          </Col>
          {/* <Col xs={{ span: 24 }} md={{ span: 24 }} xxl={{ span: 6 }} >
            <InputBox.Select
              style={{ marginBottom: 0 }}
              mode="multiple"
              placeholder="Select Customers"
              name="customers"
              showSearch
              className="multiSelect"
              optionFilterProp="children"
              filterOption={(input, option: any) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                0
              }
              options={{
                list: companyList,
                valueKey: "id",
                textKey: "company_name",
              }}
            />
          </Col> */}


        </Row>
      </Col>
      <Col xs={{ span: 24 }} md={{ span: 24 }} xxl={{ span: 4 }}>
        <Space align="end" >
          <CancelButton title="Reset" key={2} onClick={() => onReset()} />
          <SaveButton
            name="Apply"
            key={1}
            form="filterForm"
            disabled={disabled}
            loading={saving}
          />

        </Space>
      </Col>
    </Row>

  </FormBox>





  return (
    <>
      {/* <Space direction="vertical" size="small" style={{ display: 'flex' }}> */}
      <div style={{ marginBottom: '2rem' }}>
        <ToolBar breadcrumbs={ActivityLogBreadcrumb} >

          <RecordPerPage
            perPage={perPage}
            onChange={(perPageSize: number) => {
              dispatch(setPerPage(perPageSize));
            }}
          />
        </ToolBar>
      </div>


      <ContentBox >
      <Row  gutter={[15, 15]}  style={{marginBottom:'1rem'}}>

        <Col xxl={{ span: 24 }} lg={{ span: 24 }} md={{ span: 24 }}>
          <Space direction="vertical"
            style={{ width: '100%', textAlign: 'start', padding: 0 }}
          >
            <Card style={{ width: '100%', textAlign: 'start', padding: 0 }}>
              {FilterForm}
            </Card>

          </Space>
        </Col>
      </Row>
        <div style={{height:'88%'}}>

        <Listing
          moduleInfo={moduleInfo}
          handleViewClick={(data: any) => {
            getDetails(data, CONSTANT.DRAWER_TYPE.VIEW);
          }}
        />
        </div>
        <ViewDrawer
          titleName={moduleInfo.title}
          open={viewDrawer}
          close={() => dispatch(setDetails(null)) && setViewDrawer(false)}
        />

      </ContentBox>

      {/* </Space> */}
    </>
  );
};

export default ActivityLogManagement;
